/**
 * Politique unique des notifications dashboard (Sonner via `notify`).
 * Titres en français, courts, sans emoji. Description optionnelle.
 */

export const NOTIFICATION_DURATION_MS = {
  success: 3500,
  error: 7000,
  warning: 5000,
  info: 4000,
} as const;

/** Chargement Sonner : persistant jusqu’à `notify.dismiss(id)`. */
export const NOTIFICATION_LOADING_PERSISTENT = Number.POSITIVE_INFINITY;

export const NOTIFY_DEFAULTS = {
  fallbackTitle: "Notification",
  errorTitle: "Une erreur est survenue",
} as const;

/** Garde-fous dev uniquement (voir `notify.ts`). */
export const NOTIFY_DEV = {
  warnOnMissingTitle: true,
} as const;

/**
 * Identifiants stables pour dédupliquer les toasts (même `id` = remplacement, pas d’empilement).
 */
export const notifyToastIds = {
  orderInserted: (orderId: string) => `order-insert-${orderId}`,
  bulkProductsDeleted: (storeId: string) => `bulk-products-deleted-${storeId}`,
  /** Export / import CSV côté utilitaire ou écran (clé = contexte stable, ex. nom de fichier). */
  importExport: (kind: string, key: string) => {
    const safe = String(key).replace(/\s+/g, "-").slice(0, 120);
    return `import-export-${kind}-${safe}`;
  },
};
